import type { FaireProductEntity } from "../../entity_types/product";

export const plant_dyed_6: FaireProductEntity = {
  token: "plant-dyed-6",
  type: "product",
  name: "Lavender Scented Sachets",
  brandName: "West Coast Handmade",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/689f11ca6f3bd5563d045c2bdc1800598f319573fa179089e7b20dc3f6a47d2d.png",
  priceDollars: 3,
  freeShipping: false,
  brandAvatarUrl:
    "https://cdn.prerelease.faire.dev/fastly/689f11ca6f3bd5563d045c2bdc1800598f319573fa179089e7b20dc3f6a47d2d.png",
  weight: 0.1,
  dimensions: {
    width: 3,
    height: 4,
    depth: 1,
  },
  description: "Lavender scented sachets with plant-dyed textiles",
  categoryTokens: ["cat_accessories"],
  tags: [
    "plant-dyed",
    "natural-dye",
    "sustainable-textiles",
    "lavender",
    "sachet",
    "premium",
  ],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-compass-migration",
  },
};
